export const assetLinksTable = {
  headers: {
    assetNo: '資產編號',
    name: '名稱',
    quantity: '數量',
    parentAsset: '母資產',
  },
}
